module.exports = __webpack_public_path__ + "static/media/POCLogo.dc32b667.svg";